var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.5H1.75C1.125 0.5 0.5 1.125 0.5 1.75V14.25C0.5 14.875 1.125 15.5 1.75 15.5H14.25C14.875 15.5 15.5 14.875 15.5 14.25V1.75C15.5 1.125 14.875 0.5 14.25 0.5H9.25V1.75H8V0.5ZM8 3H6.75V1.75H8V3ZM8 4.25V3H9.25V4.25H8ZM8 5.5V4.25H6.75V5.5H8ZM8 5.5V6.75H9.25V5.5H8Z",
    fill: "#0E273D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.2fe2c05aaefa5005e7ef5efc4c98b908.svg";
export { ForwardRef as ReactComponent };